export const BACK_TO_TOP = {
    init: () => {
        console.dir(document.getElementById('backToTop'));
        if (document.getElementById('backToTop')) {
            document.getElementById('backToTop').addEventListener('click', () => {


                document.querySelector('.modal-dialog-promotion').scrollTo({ top: 0, behavior: 'smooth' });
            });
        }
    }
}

BACK_TO_TOP.init();